import { Card } from '@/components/ui';
import { Skeleton } from '@/components/custom';

type TProps = {
	count?: number;
};

const DataTableMobileSkeleton = ({ count = 3 }: TProps) => {
	return (
		<div className="space-y-4">
			{Array.from({ length: count }).map((_, i) => (
				<Card key={i} className="p-4 space-y-3">
					<Skeleton className="h-32 w-full" />
					<Skeleton className="h-5 w-3/4" />
					<div className="flex gap-2">
						<Skeleton className="h-6 w-24" />
						<Skeleton className="h-6 w-20" />
					</div>
					<Skeleton className="h-4 w-full" />
					<Skeleton className="h-4 w-2/3" />
					<Skeleton className="h-4 w-14" />
				</Card>
			))}
		</div>
	);
};

export default DataTableMobileSkeleton;
